import React from 'react'
import { useSearchConditionPc } from '../hooks/useSearchCondition'
import { Select, SelectProps } from 'antd'
import { FilterSelectPc } from '../FilterSelect/FilterSelectPc'

export interface FilterSelectWarehouseTypePcProps extends SelectProps {

}

const FilterSelectWarehouseTypePc = (props: FilterSelectWarehouseTypePcProps) => {
  const { value, placeholder = '仓库类型', ...rest } = props
  const { searchCondition, loading, getInitData } = useSearchConditionPc({ stock: ['in_type', 'out_type'] })

  return (
    <FilterSelectPc
      allowClear
      dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
      style={{ width: '100%' }}
      mode='multiple'
      value={value}
      placeholder={placeholder}
      options={[...searchCondition.stock?.in_type || [], ...searchCondition.stock?.out_type || []]}
      loading={loading}
      getInitData={getInitData}
      {...rest}
    />
  )
}

export default FilterSelectWarehouseTypePc;